<template>
  <div id="header-home-top">
    <div class="lg-container px-10">
      <div class="row pl-20 flex">
        <router-link to="/" hreflang="en-MY" class=" pull-left hidden-xs hidden-sm"><i class="logo ml-10 mt-10"></i></router-link>
        <div class="flex whitespace-no-wrap md:pr-0 mt-2 margin-left-auto ">
          <home-user-top-desktop></home-user-top-desktop>
          <home-user-top-mobile></home-user-top-mobile>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    components: {
      HomeUserTopMobile: () => import('@/components/home/HomeUserTopMobile'),
      HomeUserTopDesktop: () => import('@/components/home/HomeUserTopDesktop')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/HomeHeader.vue